import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
import { MixDetailsState } from "../../entities/Mix";

export const getRoot = (state: RootState) => state.mixDetails;

export const getMixDetails = createSelector(
  [getRoot],
  (mixDetails: MixDetailsState) => mixDetails.data,
);

export const getMixLoading = createSelector(
  [getRoot],
  (mixDetails: MixDetailsState) => mixDetails.isLoading,
);
